import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBarButton from "../buttons/NavBarButton";
import Space from "../layout/Space";
import { logoutUser, useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import PrimaryButton from "../buttons/PrimaryButton";
import { Switch } from "@mui/material";
import { useAppContext } from "../config/AppContext";
import TextFieldMicro from "../textfields/TextFieldMicro";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getRefFromId,
  listenCollection,
} from "../models/DataFunctions";
import DropDownOrg from "../dropdowns/DropDownOrg";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import loginAs from "../api/loginAs";

import { EasySwitch } from "../textfields/EasySwitch";
import Tippy from "@tippyjs/react";
import { Spin } from "antd";
import sendRequest from "../api/send/sendRequest";
import updateDocApi from "../api/database/updateDocApi";
import TextField2 from "../textfields/TextField2";
import { isLightAndonlyOneMaster } from "./VisibilityHelpers";
import SmallSpinner from "../loading/SmallSpinner";
import TaskDisplay from "./TaskDisplay";
import { useSnackbar } from "notistack";

function NavBar({
  actualpage,
  userData,
  orgData,
  masterData,
  local_version,
  override_id = null,
  navigateWorkspace,
  workspaceData,
  handleLogout,
  handleLoginAs,
  workspaces,
}) {
  const { currentUser, loading } = useAuth();
  const { appState, setAppState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [url, setUrl] = useState("http://127.0.0.1:8000/");
  const [showWorkspaces, setShowWorkspaces] = useState(false);

  const [messageNewVersion, setMessageNewVersion] = useState(false);
  const [client_notify, setClientNotify] = useState(false);
  const [vote_object, setVoteObject] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleWorkspace, setIsVisibleWorkspace] = useState(false);
  const [isProd, setIsProd] = useState(false);
  const [settings_open, setSettingsOpen] = useState(false);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const unsubscribeMessages = useRef(null);
  const unsubscribeMessagesPartner = useRef(null);

  useEffect(() => {
    if (!orgData?.id) return;

    const countUnread = (folders) =>
      folders.filter((f) => f.notified_orgs_id?.includes(orgData.id)).length;

    if (workspaceData?.master_id) {
      // Client/partner view: scope by master, filter by client_id or partners_id
      let clientCount = 0;
      let partnerCount = 0;
      const update = () => setUnreadMessageCount(clientCount + partnerCount);

      listenCollection(
        "folder",
        [
          { field: "client_id", operator: "==", value: orgData.id },
          { field: "master_id", operator: "==", value: workspaceData.master_id },
        ],
        1000,
        null,
        "asc",
        (folders) => { clientCount = countUnread(folders); update(); },
        unsubscribeMessages
      );
      listenCollection(
        "folder",
        [
          { field: "partners_id", operator: "array-contains", value: orgData.id },
          { field: "master_id", operator: "==", value: workspaceData.master_id },
        ],
        1000,
        null,
        "asc",
        (folders) => { partnerCount = countUnread(folders); update(); },
        unsubscribeMessagesPartner
      );
    } else {
      // Master view: scope by master_id = orgData.id
      listenCollection(
        "folder",
        [{ field: "master_id", operator: "==", value: orgData.id }],
        1000,
        null,
        "asc",
        (folders) => setUnreadMessageCount(countUnread(folders)),
        unsubscribeMessages
      );
    }

    return () => {
      if (unsubscribeMessages.current) unsubscribeMessages.current();
      if (unsubscribeMessagesPartner.current) unsubscribeMessagesPartner.current();
    };
  }, [orgData?.id, workspaceData?.master_id]);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleVote = async (vote) => {
    let voting_ref = getRefFromId("maintenance", "survey");
    let vote_object = await getDocDataByRef(voting_ref);
    setVoteObject(vote_object);
    if (!vote) return;
    let opposite_vote = vote === "old" ? "new" : "old";
    // the structure is { old : [user_id_1, ...], new : [user_id_2, ...] }]
    if (!vote_object[vote].includes(currentUser.uid)) {
      vote_object[vote].push(currentUser.uid);
    }
    if (vote_object[opposite_vote].includes(currentUser.uid)) {
      vote_object[opposite_vote].splice(
        vote_object[opposite_vote].indexOf(currentUser.uid),
        1
      );
    }

    let body = {
      old: vote_object.old,
      new: vote_object.new,
    };
    let message =
      "Vote enregistré pour la vue dossier : " + vote === "old"
        ? "ancienne"
        : "nouvelle" +
          "\nRésultats : \n" +
          vote_object.old.length +
          " votes pour l'ancienne vue \n" +
          vote_object.new.length +
          " votes pour la nouvelle vue";

    const token = await getOrRefreshFirebaseToken();
    await sendRequest("", message, currentUser?.email, "", "", token, prefix);

    await updateDocApi(voting_ref, body, prefix);
    setVoteObject(body);
    handleClickVariant("Merci pour votre vote", "success");
  };
  useEffect(() => {
    setIsVisible(settings_open);
    handleVote();
  }, [settings_open]);
  useEffect(() => {
    setIsVisibleWorkspace(showWorkspaces);
  }, [showWorkspaces]);

  const handleCheckOverrideInPersonalWorkspace = async () => {
    if (location.pathname.includes("workspace")) {
      let actual_workspace_id = location.pathname
        .split("workspace")[1]
        .split("/")[1];
      if (actual_workspace_id === "myself" && override_id) {
        console.warn("overriding in a personal worspace ABORT OVERRIDE");
        navigateWorkspace("abort_override");
        return;
      }
    }
  };

  const handleFetchData = async () => {
    if (userData && currentUser) {
      if (location.pathname.includes("workspace")) {
        let actual_workspace_id = location.pathname
          .split("workspace")[1]
          .split("/")[1];
        let workspace = workspaces.find((w) => w.id === actual_workspace_id);
        let selected_workspace = workspace;

        if (
          workspaceData?.master_id !== orgData.id &&
          workspaceData?.partner_id !== orgData.id &&
          actual_workspace_id !== "myself"
        ) {
          console.warn("actual org is a partner, nor master, ABORT OVERRIDE");

          navigateWorkspace("abort_override");
        }
        if (actual_workspace_id === "myself" && override_id) {
          console.warn("overriding in a personal worspace ABORT OVERRIDE");
          navigateWorkspace("abort_override");
          return;
        }
        if (actual_workspace_id === "myself") {
          console.warn("my self workspace selected, no override needed");
          return;
        }
        const master = await getOrgById(workspaceData?.master_id);

        // if override
        if (override_id) {
          const overriding_master_user = await getUserById(currentUser.uid);
          const overriding_master = await getOrgById(
            overriding_master_user.org_id
          );

          if (master.id !== overriding_master.id) {
            console.warn(
              `this master ${master.id} is not the same as the workspace master ABORT OVERRIDE`
            );
            // this master who is overriding should not be able to see the workspace
            navigateWorkspace("abort_override");

            return;
          }
        }
      } else {
        console.warn("no workspace in url");
      }
    } else {
      console.warn("userData or currentUser is null, aborting fetch data");
    }
  };

  const handleSwitchWorkspace = async (workspace) => {
    // check if already in a workspace
    if (workspace.id === "myself") {
      console.warn("switching to myself");
      navigateWorkspace("/home", orgData, workspace.id);
      return;
    } else {
      let path = "/home";
      console.warn("switching to workspace", workspace.id);
      navigateWorkspace(path, orgData, workspace.id);
    }
  };

  const [workspace_hovered, setWorkspaceHovered] = useState(null);

  useEffect(() => {
    if (currentUser && currentUser?.email !== userData?.email) {
      handleCheckOverrideInPersonalWorkspace(); // Fetch user data when currentUser is available
    }
    setUrl(appState.dev_url);
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  useEffect(() => {
    if (currentUser && currentUser?.email !== userData?.email) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
    setUrl(appState.dev_url);
  }, [workspaces, workspaceData]); // Dependency array ensures this runs when currentUser changes

  if (loading || !currentUser || !userData || !orgData) {
    return (
      <div className="flex flex-col items-center justify-center h-screen w-screen">
        <SmallSpinner></SmallSpinner>
      </div>
    ); // Show loading state while checking auth or if currentUser is null
  }

  // <div className="flex flex-row  max-w-full pl-1 mr-5 text-gray-800 text-h3  bg-neutral-100   rounded-md  border-1   ">
  //{orgData.name}
  // </div>

  return (
    <div className="flex flex-col  h-full w-60 min-w-60 bg-transparent pointer-events-auto p-2 ">
      {settings_open && (
        <div
          onClick={() => setSettingsOpen(false)}
          className="fixed h-screen w-screen  top-0 left-0  z-50 flex justify-center items-center"
        >
          <div
            className={`absolute bottom-4 z-40 w-c200 flex flex-col ${
              isVisible ? "scale-100 opacity-100 " : "scale-90 opacity-0"
            }  duration-75 transition-all   h-fit text-shadow_50 border-1 border-shadow_10  bg-white p-4 shadow-xl rounded-lg`}
            style={{ left: "230px" }}
          >
            <div className="flex flex-row gap-2 items-center mb-4">
              <div className="h-10 w-10  min-h-10 min-w-10 rounded-full bg-indigo-50 flex items-center justify-center text-white">
                {settings_open.photo && (
                  <img
                    src={
                      settings_open.photo || "https://via.placeholder.com/150"
                    }
                    className="h-10 w-10 rounded-full"
                  ></img>
                )}
              </div>
              <div className="flex flex-col ">
                <div className="text-h3 font-semibold">
                  {settings_open.display_name}
                </div>
                <div className="text-h4 ">
                  {settings_open.email.substring(0, 15)}
                </div>
              </div>
            </div>

            {(!override_id || isLightAndonlyOneMaster(orgData)) && (
              <>
                {" "}
                <div
                  onClick={() => {
                    navigateWorkspace("/account");
                    setSettingsOpen(false);
                  }}
                  className="flex flex-row gap-2 w-full pr-4  p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
                >
                  <Icon1 icon_name="user" size={20} fill="grey" />
                  <div className="text-h3 font-semibold ">Compte</div>
                </div>
                <div
                  onClick={() => {
                    navigateWorkspace("/organisation");
                    setSettingsOpen(false);
                  }}
                  className="flex flex-row gap-2 w-full pr-4 p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
                >
                  <Icon1 icon_name="organisation" size={20} fill="grey" />
                  <div className="text-h3 font-semibold ">Entreprise</div>
                </div>{" "}
                <div
                  onClick={() => {
                    navigateWorkspace("/account");

                    setSettingsOpen(false);
                  }}
                  className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
                >
                  <Icon1 icon_name="settings" size={20} fill="grey" />
                  <div className="text-h3 font-semibold ">Paramètres</div>
                </div>
              </>
            )}

            {!override_id && (
              <div
                onClick={() => {
                  navigateWorkspace("/facturation");
                  setSettingsOpen(false);
                }}
                className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
              >
                <Icon1 icon_name="facturation" size={20} fill="grey" />
                <div className="text-h3 font-semibold ">Facturation</div>
              </div>
            )}
            {override_id && (
              <div
                onClick={() => {
                  navigateWorkspace("abort_override");
                  setSettingsOpen(false);
                }}
                className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
              >
                <Icon1 icon_name="logout" size={20} fill="grey" />
                <div className="text-h3 font-semibold ">Vers mon compte</div>
              </div>
            )}
            {!override_id && (
              <div
                onClick={handleLogout}
                className="flex flex-row gap-2  pr-4 w-full p-1 items-center  hover:bg-gray-100 rounded-lg cursor-pointer "
              >
                <Icon1 icon_name="logout" size={20} fill="grey" />
                <div className="text-h3 font-semibold ">Déconnexion</div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="flex max-w-full h-full max-h-full  flex-col  bg-neutral-50 rounded-md border-1 border-neutral-200  ">
        <div className="relative flex flex-col  flex-1 max-h-full  pr-4 max-w-full overflow-y-auto">
          <Space y={15} />
          <div className="flex flex-row gap-3 pl-4 items-center ml-1 mb-4">
            <div className="relative">
              <Icon1 icon_name="hexagone" size={24}></Icon1>
            </div>
            <div className="text-black select-none text-h2 font-semibold">
              hexagone
            </div>{" "}
          </div>
          <div className="absolute top-1 right-1 text-h6 h-0 text-shadow_10 hover:text-shadow_50 duration-500">
            v.
            {local_version?.substring(6, 8) +
              "/" +
              local_version?.substring(4, 6) +
              "/" +
              local_version?.substring(8, 10) +
              "h" +
              local_version?.substring(10, 12)}
          </div>
          <div
            onClick={() => setShowWorkspaces(true)}
            className={`flex flex-row relative select-none cursor-pointer max-w-full justify-between gap-3 px-2 py-1 ml-1 mb-4 items-center rounded-md hover:bg-neutral-100 `}
          >
            {(workspaces
              ? workspaces?.reduce((sum, w) => sum + (w.counter || 0), 0) > 0
              : orgData.personal_workspace?.counter > 0) && (
              <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-red-400"></div>
            )}
            <div className="flex flex-row gap-1 max-w-full ">
              <div className=" w-10 h-10 rounded-full  items-center  flex justify-center relative">
                <Icon1 icon_name="workspace" size={25} fill="grey"></Icon1>
              </div>
              <div className="flex flex-col flex-grow max-w-full ">
                <div className="text-h3  text-nowrap text-black text-ellipsis overflow-hidden select-none max-w-24">
                  Espace de
                </div>
                <div
                  className="text-h6 text-shadow_50 font-medium
                 max-h-4  text-ellipsis overflow-hidden select-none w-24 break-all
              "
                >
                  {workspaceData ? workspaceData.master_name : orgData.name}
                </div>
              </div>{" "}
            </div>
            <div className="">
              <Icon1 icon_name="replace" size={16} fill="grey"></Icon1>
            </div>
          </div>{" "}
          {showWorkspaces && (
            <div
              className="fixed select-none h-screen w-screen top-0 left-0  z-50 flex justify-center items-center"
              onClick={() => setShowWorkspaces(false)}
            >
              <div
                className={`absolute  ${isVisibleWorkspace ? "scale-100 opacity-100 " : "scale-90 opacity-0"}
            ${override_id ? "top-28" : "top-16"} z-60 w-c300 flex flex-col duration-75 transition-all   h-fit text-shadow_50 border-1 border-shadow_10  bg-white p-1 shadow-xl rounded-lg`}
                style={{ left: "220px" }}
              >
                <div className="flex flex-col gap-1">
                  {workspaces
                    ?.concat(
                      orgData.facturation?.plan !== "free"
                        ? [
                            {
                              id: "myself",
                              master_name: orgData.name,
                            },
                          ]
                        : []
                    )
                    .filter((workspace) => {
                      return override_id
                        ? workspace?.master_id === workspaceData?.master_id
                        : true;
                    })
                    .map((workspace, index) => (
                      <div
                        onMouseEnter={() => setWorkspaceHovered(workspace.id)}
                        onMouseLeave={() => setWorkspaceHovered(null)}
                        onClick={() =>
                          workspace.id === workspaceData?.id
                            ? {}
                            : handleSwitchWorkspace(workspace)
                        }
                        key={index}
                        className={`flex flex-row gap-2 items-center   p-2 rounded-md   ${
                          workspace.id === (workspaceData?.id || "myself")
                            ? " border-l-2 border-teal-500 "
                            : "bg-white hover:bg-teal-50 cursor-pointer hover:border-1  hover:border-teal-200"
                        }`}
                      >
                        <div className=" w-10 h-10 rounded-full  items-center  flex justify-center relative">
                          <Icon1
                            icon_name="workspace"
                            size={25}
                            fill={
                              workspace.id === workspace_hovered ||
                              workspace.id === (workspaceData?.id || "myself")
                                ? "#14b8a6"
                                : "grey"
                            }
                          ></Icon1>
                        </div>
                        <div className="flex flex-col flex-grow max-w-full ">
                          <div className="text-h3 text-nowrap text-black text-ellipsis overflow-hidden select-none max-w-24">
                            Espace de
                          </div>
                          <div
                            className="text-h6 text-shadow_50
                 max-h-4  text-ellipsis overflow-hidden select-none 
              "
                          >
                            {workspace.master_name || workspace.id}
                          </div>
                        </div>{" "}
                        {true && (
                          <div className="w-fit px-2 h-6 items-center justify-center flex rounded-full bg-white border-1 border-red-100 text-h2 text-red-500">
                            {workspace.id === "myself"
                              ? orgData.personal_workspace?.counter
                              : workspace.counter}
                          </div>
                        )}
                      </div>
                    ))}
                  <div
                    className={`flex flex-row gap-4 items-center   p-2 rounded-md  bg-white "
                        `}
                  >
                    <div className="flex flex-col flex-grow max-w-full ">
                      <div className="text-h5  text-shadow_50 select-none ">
                        Chaque espace de travail est lié aux dossiers d'une
                        entreprise
                      </div>
                    </div>{" "}
                  </div>
                </div>{" "}
              </div>
            </div>
          )}
          <div className="flex flex-col pl-3">
            {/* Navigation buttons */}
            <NavBarButton
              icon="home"
              squeezed={userData.admin && !appState.hide_admin}
              isActualPage={location.pathname.includes("/home")}
              onClick={() => navigateWorkspace("/home", orgData)}
            >
              Accueil
            </NavBarButton>
            <NavBarButton
              icon="user"
              visible={!workspaceData}
              squeezed={userData.admin && !appState.hide_admin}
              isActualPage={location.pathname.includes("/partner")}
              onClick={() => navigateWorkspace("/partners", orgData)}
            >
              Partenaires
            </NavBarButton>
            <NavBarButton
              icon="folder"
              squeezed={userData.admin && !appState.hide_admin}
              isActualPage={location.pathname.includes("/folder")}
              onClick={() => navigateWorkspace("/folders", orgData)}
            >
              Dossiers
            </NavBarButton>
            <NavBarButton
              icon="devis"
              squeezed={userData.admin && !appState.hide_admin}
              visible={
                !workspaceData ||
                workspaceData.permissions?.new_estimates === true
              }
              isActualPage={location.pathname.includes("/invoice")}
              onClick={() => navigateWorkspace("/invoices", orgData)}
            >
              Devis
            </NavBarButton>{" "}
            <NavBarButton
              icon="payments"
              squeezed={userData.admin && !appState.hide_admin}
              visible={
                !workspaceData || workspaceData.permissions?.folders === true
              }
              isActualPage={location.pathname.includes("/payment")}
              onClick={() => navigateWorkspace("/payments", orgData)}
            >
              Paiements
            </NavBarButton>
            <NavBarButton
              icon="planning"
              squeezed={userData.admin && !appState.hide_admin}
              isActualPage={location.pathname.includes("/planning")}
              onClick={() => navigateWorkspace("/planning", orgData)}
            >
              Planning
            </NavBarButton>
            {/* <NavBarButton
              icon="inbox"
              visible={!workspaceData}
              squeezed={userData.admin && !appState.hide_admin}
              isActualPage={location.pathname.includes("/emails-sync")}
              onClick={() => navigateWorkspace("/emails-sync", orgData)}
            >
              Emails
            </NavBarButton> */}
            <NavBarButton
              icon="message"
              squeezed={userData.admin && !appState.hide_admin}
              isActualPage={location.pathname.includes("/messages")}
              onClick={() => navigateWorkspace("/messages", orgData)}
              alert={unreadMessageCount > 0}
            >
              Messages
            </NavBarButton>
            <NavBarButton
              icon="bookshelf"
              squeezed={userData.admin && !appState.hide_admin}
              visible={workspaceData}
              isActualPage={location.pathname.includes("/bookshelfclient")}
              onClick={() => navigateWorkspace("/bookshelfclient", orgData)}
            >
              Bibliothèque
            </NavBarButton>
            {false && (
              <NavBarButton
                icon="forum"
                squeezed={userData.admin && !appState.hide_admin}
                visible={!workspaceData}
                isActualPage={location.pathname.includes("/forum")}
                onClick={() => navigateWorkspace("/forum", orgData)}
              >
                Forum
              </NavBarButton>
            )}
            <NavBarButton
              icon="stats"
              squeezed={userData.admin && !appState.hide_admin}
              visible={!workspaceData}
              isActualPage={location.pathname.includes("/stats")}
              onClick={() => navigateWorkspace("/stats", orgData)}
            >
              Statistiques
            </NavBarButton>
            <NavBarButton
              icon="settings"
              visible={!override_id || isLightAndonlyOneMaster(orgData)}
              onClick={() => navigateWorkspace("/parameters", orgData)}
              isActualPage={[
                "/account",
                "/organisation",
                "/facturation",
                "/products",
                "/devisparams",
                "/controlparams",
                "/stripe",
                "/bridge",
                "/cil",
                "/infiltrea",
                "/parameters",

                "/rtb",
                "/xml",
                "/email",
                "/extraction-ia",
                "/perso",
                "/tags",
                "/formparams",
                "/validation",
                "/mobileapp",
                "/rdvparams",
                "/gallery",
                "/invitemanager",
                "/reminders",
                "/pennylane",
                "/packs",
                "/masters",
                "/bookshelf",
                "/widget",
                "/google-calendar",
                "/documents",
              ].includes(
                location.pathname.includes("workspace")
                  ? "/" + location.pathname.split("workspace")[1].split("/")[2]
                  : location.pathname
              )}
            >
              Paramètres
            </NavBarButton>
            <Space y={30}></Space>
            {/* Admin-specific buttons */}{" "}
            {userData.admin && (
              <div className="flex flex-row items-center gap-2 p-0 m-0">
                <div className="text-h3 text-shadow_50 font-medium">HSP</div>
                <EasySwitch
                  checked={appState.hide_admin}
                  onChange={(checked) =>
                    setAppState((prevState) => ({
                      ...prevState,
                      hide_admin: checked,
                    }))
                  }
                />
              </div>
            )}
            {userData.admin && !appState.hide_admin && (
              <div className="flex flex-col gap-0">
                <NavBarButton
                  icon="home"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/dashboard", orgData)}
                  isActualPage={location.pathname === "/admin/dashboard"}
                >
                  Dashboard
                </NavBarButton>
                <NavBarButton
                  icon="email"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/hexamails", orgData)}
                  isActualPage={location.pathname === "/admin/hexamails"}
                >
                  Hexamails
                </NavBarButton>
                <NavBarButton
                  icon="logs"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/logs", orgData)}
                  isActualPage={location.pathname === "/admin/logs"}
                >
                  Logs
                </NavBarButton>{" "}
                <NavBarButton
                  icon="smartphone"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/applogs", orgData)}
                  isActualPage={location.pathname === "/admin/applogs"}
                >
                  AppLogs
                </NavBarButton>
                <NavBarButton
                  icon="bridge"
                  squeezed={true}
                  onClick={() =>
                    navigateWorkspace("/admin/admin-payments", orgData)
                  }
                  isActualPage={location.pathname === "/admin/admin-payments"}
                >
                  Bridge
                </NavBarButton>
                <NavBarButton
                  icon="transactions"
                  squeezed={true}
                  onClick={() =>
                    navigateWorkspace("/admin/transactions", orgData)
                  }
                  isActualPage={location.pathname === "/admin/transactions"}
                >
                  Transactions
                </NavBarButton>
                <NavBarButton
                  icon="transactions"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/payouts", orgData)}
                  isActualPage={location.pathname === "/admin/payouts"}
                >
                  Virements
                </NavBarButton>
                <NavBarButton
                  icon="user"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/users", orgData)}
                  isActualPage={location.pathname === "/admin/users"}
                >
                  Utilisateurs
                </NavBarButton>
                <NavBarButton
                  icon="user"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/guests", orgData)}
                  isActualPage={location.pathname === "/admin/guests"}
                >
                  Sessions part
                </NavBarButton>
                <NavBarButton
                  icon="user"
                  squeezed={true}
                  onClick={() =>
                    navigateWorkspace("/admin/setup-sessions", orgData)
                  }
                  isActualPage={location.pathname === "/admin/setup-sessions"}
                >
                  Sessions setup
                </NavBarButton>
                <NavBarButton
                  icon="question"
                  onClick={() =>
                    navigateWorkspace("/admin/support-requests", orgData)
                  }
                  isActualPage={location.pathname === "/admin/support-requests"}
                  squeezed={true}
                >
                  Tickets support
                </NavBarButton>
                <NavBarButton
                  icon="settings"
                  squeezed={true}
                  onClick={() =>
                    navigateWorkspace("/admin/action-admin", orgData)
                  }
                  isActualPage={location.pathname === "/admin/action-admin"}
                >
                  Actions admin
                </NavBarButton>
                <NavBarButton
                  icon="organisation"
                  squeezed={true}
                  onClick={() => navigateWorkspace("/admin/orgs", orgData)}
                  isActualPage={location.pathname === "/admin/orgs"}
                >
                  Orgs
                </NavBarButton>
                <Space y={10}></Space>
                <div className="flex flex-row items-center gap-2 p-0 m-0">
                  <div className="text-h3 text-shadow_50 font-medium">
                    Local
                  </div>
                  <EasySwitch
                    checked={appState.dev}
                    onChange={(checked) =>
                      setAppState((prevState) => ({
                        ...prevState,
                        dev: checked,
                      }))
                    }
                  />
                </div>{" "}
                {appState.dev && (
                  <div className="pr-5">
                    <TextFieldMicro
                      label="url"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                      className="text-h3 text-shadow_50"
                      sx={{
                        fontSize: "10px",
                      }}
                    ></TextFieldMicro>
                  </div>
                )}
              </div>
            )}
          </div>
          <Space y={10}></Space>
        </div>
        <div className="flex flex-col justify-end    w-full relative ">
          {userData.admin && !appState.hide_admin && (
            <div className=" flex flex-row gap-2">
              <SecondaryButton
                onClick={() => handleLoginAs("1aihbaoDIBetJDTXNuVnWXnguiF3")}
              >
                OEC
              </SecondaryButton>
              <SecondaryButton
                onClick={() => handleLoginAs("OChVGuPmZGS0mZGriZ1J9x5fm4F2")}
              >
                DER
              </SecondaryButton>
              <SecondaryButton
                onClick={() => handleLoginAs("TIKZNJtFNdNz4xfoHq5bkURA7l12")}
              >
                JAD
              </SecondaryButton>
              <SecondaryButton
                onClick={() => handleLoginAs("CIbjhJGQZaeQYuEfxbymvFwyBx83")}
              >
                ABC
              </SecondaryButton>
            </div>
          )}
          {userData.id === "TIKZNJtFNdNz4xfoHq5bkURA7l12" && (
            <div className=" flex flex-row gap-2">
              <SecondaryButton
                onClick={() => handleLoginAs("CIbjhJGQZaeQYuEfxbymvFwyBx83")}
              >
                ABC
              </SecondaryButton>
            </div>
          )}
          {userData.id === "CIbjhJGQZaeQYuEfxbymvFwyBx83" && (
            <div className=" flex flex-row gap-2">
              <SecondaryButton
                onClick={() => handleLoginAs("TIKZNJtFNdNz4xfoHq5bkURA7l12")}
              >
                JAD
              </SecondaryButton>
            </div>
          )}{" "}
          <div
            onClick={() =>
              setSettingsOpen(
                settings_open
                  ? null
                  : {
                      display_name: userData.display_name,
                      email: userData.email,
                      photo: userData.photo,
                      niveau: false,
                    }
              )
            }
            className="flex flex-row  select-none cursor-pointer max-w-full justify-between gap-3 p-2 m-2  items-center rounded-md hover:bg-neutral-100 "
          >
            <div className="flex flex-row gap-3 max-w-full">
              <div className=" min-w-10 h-10 rounded-full bg-white flex justify-center relative">
                <img
                  className="w-10 h-10 rounded-full object-center object-contain "
                  src={
                    userData.photo ||
                    "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                  }
                ></img>
              </div>
              <div className="flex flex-col flex-grow max-w-full ">
                <div className="text-h3 text-nowrap text-black text-ellipsis overflow-hidden select-none max-w-24">
                  {userData.display_name}
                </div>
                <div
                  className="text-h6 text-shadow_50
                 max-h-4  text-ellipsis overflow-hidden select-none max-w-24
              "
                >
                  {userData.email}
                </div>
              </div>{" "}
            </div>
            <div className="">
              <Icon1 icon_name="settings" size={20} fill="grey"></Icon1>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

export default NavBar;
